import { ConfigProvider, theme } from 'antd'
import * as React from 'react'
import { Route, Routes } from 'react-router-dom'
import { useUser } from 'src/context/UserContext'
import { App } from '../app/App'
import { LoginForm } from '../loginForm/LoginForm'

export const Main: React.FC = () => {

    const userContext = useUser()

    return (
        <ConfigProvider
            theme={{
                algorithm: userContext.blackTheme ? theme.darkAlgorithm : theme.defaultAlgorithm,
                // algorithm: [theme.darkAlgorithm, theme.compactAlgorithm]

                token: {
                    colorPrimary: '#5574A3',
                    colorError: '#E9204F',
                    colorBgLayout: userContext.blackTheme ? '#000000' : '#EAF4FF',
                    colorBorder: userContext.blackTheme ? '#424242' : '#CFDBED',
                    colorText: userContext.blackTheme ? '#ffffffd9' : '#232E3F',
                    fontFamily: 'Outfit'
                }
            }}
        >
            <Routes>
                <Route path="/login" element={<LoginForm />} />
                <Route path="*" element={<App />} />
            </Routes>
        </ConfigProvider>
    )
}


// WEBPACK FOOTER //
// ./src/component/root/Main.tsx